
<template>
  <div class="row gy-2">
    <div class="col-12">
      <h5 class="mb-3">List of Attributes</h5>
      <div class="row mb-3 gy-2 justify-content-between">
        <div class="col-lg-12 d-flex">
          <b-button variant="primary" class="" @click.prevent="popupModalShow = true" type="button">
            <i class="ri ri-add-fill align-bottom"></i> <span class="d-inline"> Create Attribute </span></b-button>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="input-group w-auto">
            <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage" :options="pageOptions"></b-form-select>
            <select @change="fetchItems()" v-model="defaultType" class="form-select flex-grow-1">
              <option value="" disabled selected>-- sort by type --</option>
              <option :value="null"> All </option>
              <option v-for="(tOption, tIndex) in typeOptions"
                      :value="tOption.value" :key="tIndex" > {{tOption.label}} </option>
            </select>
          </div>
        </div>
        <div class="col-md-5">
          <div class="input-group mb-0">
            <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control" placeholder="Search here..." aria-label="Search here..." aria-describedby="button-search_TB">
            <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span class="ri ri-search-line"></span></button>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <p class="mb-0">Showing {{paginationInfo}} results</p>
      </div>
      <div class="card">
        <div class="card-body p-3">
          <div class="table-responsive mb-0 loading-viewport">
            <CommonSpinner v-if="isLoading" :box="true" />
            <b-table striped hover ref="selectableTable" :items="pageData.data"
              :fields="columns" responsive="sm"  align="middle">
              <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                v-slot:[`head(${column.key})`] >
                  <div :key="colIndex" @click="setSortOrder(column)" class="cursor-pointer
                  d-flex align-items-center">
                    {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                  </div>
              </template>
              <template v-for="(column, colIndex) in columns.filter((i) => i.auto)"
                    v-slot:[`cell(${column.key})`]="data">
                    <div @click="navigateTo(data.item.id)" :key="colIndex"
                        :style="{ 'width': `${column.width || '8'}rem` }"
                        class="cursor-pointer d-flex align-items-center">
                        <CommonTableTemplate :item="data.item" :column="column" />
                    </div>
                </template>
                <template v-slot:cell(action)="data">
                    <div class="dropdown dropstart no-arrow">
                    <button class="dropdown-toggle btn btn-sm btn-light" type="button"
                        role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="ri-more-2-fill"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                        <button @click.prevent="initEdit(data.item)" class="dropdown-item"
                            type="button"> Edit </button>
                        </li>
                        <li>
                        <button @click.prevent="deleteItem(data.item.id)" class="dropdown-item"
                            type="button"> Delete </button>
                        </li>
                    </ul>
                    </div>
                </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <b-pagination v-model="currentPage" :limit="pageLimit" class="pagination-rounded"
        :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
      </div>
      <b-modal v-model="popupModalShow" hide-footer centered
        :title="editMode? 'Update attribute':'Add attribute'"
        title-class="fs-6" @hide="initializeAll()">
        <attribute-form v-if="popupModalShow" @closeMe="initializeAll()"
        :edit-mode="editMode" :edit-item="editItem" :type-options="typeOptions"
        @addedItem="addItem($event)" @updatedItem="updateItem($event)"  />
      </b-modal>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import AttributeForm from "@/components/forms/AttributeForm.vue"
import { commonSortingMixin } from '@/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
  name: "attribute-list",
  mixins: [
    commonSortingMixin,
    commonPaginationMixin
  ],
  components:{
    AttributeForm,
  },
  data() {
    return {
      isLoading: false,
      popupModalShow: false,
      editMode: false,
      editItem: null,
      searchQuery: "",
      columns: [
        { key: "title", auto: true, width:10, label: "Title", sortable: true },
        { key: "type", auto: true, label: "Type", sortable: true },
        { key: "is_active", auto: true, label: "Active", sortable: true },
        { key: "sort_order", auto: true, label: "Order/Rank", sortable: true },
        "action" 
      ],
      sortBy: {
        sort_column: "title",
        sort_direction: "asc"
      },
      defaultType: null,
      typeOptions:[
        // { value: "RELATIONSHIP", label: "RELATIONSHIP" }
       ],
      pageData:{
        data: []
      }
    }
  },
  methods: {
    navigateTo(id){
      // this.$router.push({path: `/attributes/${id}`});
    },
    addItem(item){
      this.pageData.data.unshift(item);
    },
    updateItem(item){
      const dataIndex = this.pageData.data.findIndex((i) => i.id == item.id)
      Object.assign(this.pageData.data[dataIndex], item)
    },
    updateSearchQuery: _.debounce(function(string) {
      this.fetchItems()
    }, 2000),
    fetchItems(page, per_page = null) {
      let payload = {page: page || 1, per_page: per_page || this.itemsPerPage,
        ...this.sortBy
      }
      if(this.searchQuery){ payload.search = this.searchQuery }
      if(this.defaultType){ payload.type = this.defaultType }
      this.isLoading = true
      this.$http.get(`/attributes?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          this.isLoading = false
          if(response.data.success){
            this.pageData = response.data.data
            this.initializeAll();
          }
        })
    },
    deleteItem(itemId) {
      this.confirmDelete({
        text: "You are about to delete a attribute",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("changeLoaderValue",true)
          this.$http.delete(`/attributes/${itemId}/delete`)
          .then(response => {
            this.$store.dispatch("changeLoaderValue",false)
            if(response.data.success){
              const ItemIndex = this.pageData.data.findIndex((item) => item.id == itemId)
              this.pageData.data.splice(ItemIndex, 1);
            }
          })
        }
      });
    },
    initEdit(item){
      this.editMode = true;
      this.editItem = {...item}
      this.popupModalShow = true  
    },
    initializeAll(){
      this.editMode = false;
      this.editItem = null;
      this.popupModalShow = false;
    },
  },
  created(){
    this.fetchItems()
  },
}

</script>

